<template>
    <!-- Sidebar -->
      <div id="sidebar-wrapper">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
          <li id="homeLink" :class="{active: activeMenu == 'home'}">
            <!-- <a href="#"><span class="fa-stack fa-lg pull-left"> <i class="fa fa-home fa-stack-1x "></i></span>Home</a> -->
            <router-link v-bind:to="{ path:'/closeticket'}" href="#">
              <span class="fa-stack fa-lg pull-left"> <i class="fa fa-home fa-stack-1x "></i></span>Home
            </router-link>

          </li>
          
          <template v-if="$store.getters.role == 1 || $store.getters.role == 2">
            <li id="reportLink" :class="{active: activeMenu == 'reports'}">
              <!-- <router-link v-bind:to="{ path:'/reports'}" href="#">
                <span class="fa-stack fa-lg pull-left"> <i class="fa fa-file fa-stack-1x "></i></span>Reports
              </router-link> -->
              <label class="tree-toggle nav-header"><span class="fa-stack fa-lg pull-left"> <i class="fa fa-bell fa-stack-1x "></i></span>Reports <i class="arrow-handle fa fa-angle-down" aria-hidden="true"></i>
              <!-- <i class="arrow-handle fa fa-angle-up" aria-hidden="true"></i>-->
              </label>
              <ul class="nav nav-list tree">
                    <li :class="{active: activeSubMenu == 'HourlyReport'}"><router-link v-bind:to="{name: 'HourlyReport'}">Hourly Report</router-link></li>
                    <li :class="{active: activeSubMenu == 'ListTicket'}"><router-link v-bind:to="{name: 'ListTicket'}">All Tickets</router-link></li>
                    <li :class="{active: activeSubMenu == 'FilteredListTicket'}"><router-link v-bind:to="{name: 'FilteredListTicket'}">Store wait times</router-link></li>
                    <li :class="{active: activeSubMenu == 'TicketPerDay'}"><router-link v-bind:to="{name: 'TicketPerDay'}">User Tickets</router-link></li>
              </ul>
            </li>
            <template v-if="$store.getters.role == 1 || $store.getters.role == 2">
              <li id="locationLink" :class="{active: activeMenu == 'location'}">
                <router-link v-bind:to="{ path:'/location'}" href="#">
                  <span class="fa-stack fa-lg pull-left"> <i class="fa fa-map-marker fa-stack-1x "></i></span>Location
                </router-link>
              </li>

              <li id="stationLink" :class="{active: activeMenu == 'stations'}">
                <label class="tree-toggle nav-header"><span class="fa-stack fa-lg pull-left"> <i class="fa fa-location-arrow fa-stack-1x "></i></span>Stations <i class="arrow-handle fa fa-angle-down" aria-hidden="true"></i></label>
                <ul class="nav nav-list tree">
                  <li :class="{active: activeSubMenu == 'ListStationLocation'}"><router-link v-bind:to="{name: 'ListStationLocation'}">List Location Stations</router-link></li>
                  <li :class="{active: activeSubMenu == 'ListStations'}"><router-link v-bind:to="{name: 'ListStations'}">List Stations</router-link></li>
                </ul>
              </li>
            </template>
          </template>

          <template v-if="$store.getters.role == 1">
          <li id="userLink" :class="{active: activeMenu == 'users'}">
            <router-link v-bind:to="{ path:'/listuserlocation'}" href="#">
              <span class="fa-stack fa-lg pull-left"> <i class="fa fa-user fa-stack-1x "></i></span>Users
            </router-link>
          </li>
          </template>

          <template v-if="$store.getters.role == 1 || $store.getters.role == 2 || $store.getters.role == 4">
            <li id="tvScreenLink" :class="{active: activeMenu == 'tvscreen'}">
              <router-link v-bind:to="{ path:'/tvscreen'}" href="#">
                <span class="fa-stack fa-lg pull-left"> <i aria-hidden="true" class="fa fa-film fa-stack-1x"></i></span>TV Screen
              </router-link>
            </li>
          </template>
         
          

          <!--<li id="ticketLink">-->
            <!--<router-link v-bind:to="{ path:'/ticketperday'}" href="#">-->
              <!--<span class="fa-stack fa-lg pull-left"> <i class="fa fa-ticket fa-stack-1x "></i></span>Ticket-->
            <!--</router-link>-->
          <!--</li>-->

          <!--<li id="avgTicketTime">-->
            <!--<router-link v-bind:to="{ path:'/avgtickettime'}" href="#">-->
              <!--<span class="fa-stack fa-lg pull-left"> <i class="fa fa-ticket fa-stack-1x "></i></span>Avg Ticket Time-->
            <!--</router-link>-->
          <!--</li>-->

          <!-- <li id="listTicketLink">
            <router-link v-bind:to="{ path:'/reports'}" href="#">
              <span class="fa-stack fa-lg pull-left"> <i class="fa fa-file fa-stack-1x "></i></span>Reports
            </router-link>
          </li> -->
        </ul>
      </div>
      <!-- Sidebar -->
</template>

<script>
    import Vue from 'vue';
    import {HTTP} from '../http-common';
    import EventBus from "../components/event-bus";
    
    var self;

    // Sidebar item to highlight for each route; add/edit pages highlight the list they belong to
    const MENU_BY_ROUTE = {
        CloseTicket: 'home',
        HourlyReport: 'reports',
        ListTicket: 'reports',
        FilteredListTicket: 'reports',
        TicketPerDay: 'reports',
        AvgTicketTime: 'reports',
        ListLocation: 'location',
        ListStationLocation: 'stations',
        AddUpdateStationLocation: 'stations',
        UpdateStationLocation: 'stations',
        ListStations: 'stations',
        AddStation: 'stations',
        UpdateStation: 'stations',
        ListUserLocation: 'users',
        AddUserLocation: 'users',
        UpdateUserLocation: 'users',
        TvScreen: 'tvscreen',
        TicketWaitingWindow: 'tvscreen',
    };

    // Submenu entry (by its route name) to highlight inside Reports / Stations
    const SUBMENU_BY_ROUTE = {
        HourlyReport: 'HourlyReport',
        ListTicket: 'ListTicket',
        FilteredListTicket: 'FilteredListTicket',
        TicketPerDay: 'TicketPerDay',
        ListStationLocation: 'ListStationLocation',
        AddUpdateStationLocation: 'ListStationLocation',
        UpdateStationLocation: 'ListStationLocation',
        ListStations: 'ListStations',
        AddStation: 'ListStations',
        UpdateStation: 'ListStations',
    };

    export default {
        name: 'Center',
        components: {
            
        },
        data() {
            return {
              
            }
        },
        computed: {
            activeMenu: function () {
                return MENU_BY_ROUTE[this.$route.name] || '';
            },
            activeSubMenu: function () {
                return SUBMENU_BY_ROUTE[this.$route.name] || '';
            },
        },
        watch: {
            // keep only the submenu holding the current page open; role-gated items render once the role loads
            '$route': function () {
                this.syncActiveTree();
            },
            '$store.getters.role': function () {
                this.syncActiveTree();
            },
        },
        beforeMount: function () {
          self = this;
        },
        mounted: function () {
            $("#menu-toggle").click(function(e) {
              e.preventDefault();
              console.log('.menu-toggle click');
              $("#wrapper").toggleClass("toggled");
            });
            $("#menu-toggle-2").click(function(e) {
                e.preventDefault();
                console.log('.menu-toggle 2 click');
                $("#wrapper").toggleClass("toggled-2");
                $('#menu ul').hide();
            });

            $('#menu ul').hide();
            $('#menu ul').children('.current').parent().show();
            // the active item is bound from the route (activeMenu / activeSubMenu), not set on click
            self.syncActiveTree();

            $('#menu').on("click", "li > label", function(event) {
              if(!$(this).parent().children('ul.tree').is(':visible')) {
                  $(this).children('.arrow-handle').removeClass('fa-angle-down');
                  $(this).children('.arrow-handle').addClass('fa-angle-up');
              } else {
                  $(this).children('.arrow-handle').removeClass('fa-angle-up');
                  $(this).children('.arrow-handle').addClass('fa-angle-down');
              }
              $(this).parent().children('ul.tree').toggle(200);
            });


        },
        methods: {
            // Master menus stay collapsed; only the one holding the current page is expanded
            syncActiveTree: function () {
                this.$nextTick(function () {
                    $('#menu > li > label.tree-toggle').each(function () {
                        var isActive = $(this).parent().hasClass('active');
                        $(this).parent().children('ul.tree').toggle(isActive);
                        $(this).children('.arrow-handle')
                            .toggleClass('fa-angle-up', isActive)
                            .toggleClass('fa-angle-down', !isActive);
                    });
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Sidebar.vue